<header class="header-outer bg-white">
<div class="flex align-items-center justify-content-between header-inner">
  <div class="flex align-items-center">
    @if (sidebarService.isMobile()) {
      <button class="menu-toggle tap-target mr-2" (click)="sidebarService.toggle()">
        <i class="pi pi-bars"></i>
      </button>
    }
    <!-- Logo -->
    <div class="flex-shrink-0">
      <img
        class="logo-image"
        src="/images/header_logo.svg"
        width="88"
        height="40"
        alt="Full Scale Solutions"
      />
    </div>
    <!-- Navigation (desktop only) -->
    @if (!sidebarService.isMobile()) {
      <nav class="ml-5 flex align-items-center gap-2-5">
        @for (item of navItems(); track item.route) {
          <a [routerLink]="item.route"
             routerLinkActive="active-link"
             #rla="routerLinkActive"
             (mouseenter)="hoveredRoute = item.route"
             (mouseleave)="hoveredRoute = null"
             class="nav-link flex align-items-center transition-colors transition-duration-200">
            <app-dynamic-icon [iconComponent]="item.iconComponent" [stroke]="rla.isActive || hoveredRoute === item.route ? '#181D27' : '#7E838F'"></app-dynamic-icon>
            <span class="text-sm-semibold">{{ item.label }}</span>
          </a>
        }
      </nav>
    }
  </div>
  <!-- Right side actions -->
  <div class="flex align-items-center gap-2-5">
    <app-button class="ml-2-5 bell-button" [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="goToNotifications()">
      <app-bell-02 stroke="#181D27"></app-bell-02>
      @if (notificationService.unreadCount() > 0) {
        <span class="bell-badge">{{ notificationService.unreadCount() }}</span>
      }
    </app-button>

    <app-button [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="onPrimaryAction()">
      <app-dynamic-icon [iconComponent]="buttonIcon()" stroke="white"></app-dynamic-icon>
      <div class="text-sm-semibold text-white btn-label">{{ buttonLabel() }}</div>
    </app-button>

    @if (!sidebarService.isMobile()) {
      <app-rectangle-5 width="1px" height="20px" stroke="#F0F2F5"></app-rectangle-5>

      <div class="user-block flex align-items-center cursor-pointer" (click)="toggleUserMenu($event)">
        <div class="avatar">
          @if (userService.isCompany()) {
            <app-building-05 stroke="#181D27" width="20px" height="18px"></app-building-05>
          } @else {
            <app-user-circle stroke="#181D27" width="20px" height="20px"></app-user-circle>
          }
        </div>
        <div class="user-info">
          @if (userService.isCompany()) {
            <span class="text-xs-semibold text-gray-900">{{userService.getUserData.companyName}}</span>
            <span class="text-xs-regular text-gray-600">{{userService.getUserData.fullName}}</span>
          } @else {
            <span class="text-xs-semibold text-gray-900">{{userService.getUserData.fullName}}</span>
            <span class="text-xs-regular text-gray-600">{{userService.getUserData.email}}</span>
          }
        </div>
        <app-chevron-right class="user-chevron" direction="down" stroke="#ADB0B8" width="7px" height="12px"></app-chevron-right>
      </div>
      <p-menu #userMenu [model]="userMenuItems" [popup]="true"></p-menu>
    }
  </div>
</div>
</header>
